export const siteLanguagesEng = 'en';
export const siteLanguagesFr = 'fr';
export const viewReservationEng = 'View Reservation';
export const viewReservationFr = 'Voir R\u00E9servation';
export const createReservationEng = 'Create Reservation';
export const createReservationFr = 'Cr\u00E9er une r\u00E9servation';
